(() => {
  const roots = document.querySelectorAll('[data-dar-cherfa]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  roots.forEach((root) => {
    const video = root.querySelector('[data-dc-autoplay]');
    const toggle = root.querySelector('[data-dc-video-toggle]');
    if (video && toggle) {
      const update = () => {
        const paused = video.paused;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        toggle.classList.toggle('is-paused', paused);
      };

      if (!reduceMotion.matches) {
        video.play().catch(() => update());
      }
      update();

      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
        update();
      });

      video.addEventListener('play', update);
      video.addEventListener('pause', update);
    }

    root.querySelectorAll('[data-dc-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-dc-slider-track]');
      const previous = slider.querySelector('[data-dc-slider-prev]');
      const next = slider.querySelector('[data-dc-slider-next]');
      if (!track || !previous || !next) return;

      const updateControls = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        const slide = track.querySelector('[data-dc-slide]');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
        track.scrollBy({ left: distance * direction, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });

    const allVideos = [...root.querySelectorAll('video')];
    allVideos.forEach((currentVideo) => {
      currentVideo.addEventListener('play', () => {
        allVideos.forEach((otherVideo) => {
          if (otherVideo !== currentVideo) otherVideo.pause();
        });
      });
    });
  });
})();
